__webpack_require__.p = "/fourier_visualizer/";